/**
 * Debug utility that only logs in development mode.
 * Prevents debug messages from leaking into production.
 */
const createDebug = () => {
  const log = (...messages: unknown[]) => {
    // @ts-ignore
    if (import.meta.env.DEV) console.log("[DEV-ONLY]", ...messages);
  };

  const warn = (...messages: unknown[]) => {
    // @ts-ignore
    if (import.meta.env.DEV) console.warn("[DEV-ONLY]", ...messages);
  };

  const error = (...messages: unknown[]) => {
    // @ts-ignore
    if (import.meta.env.DEV) console.error("[DEV-ONLY]", ...messages);
  };

  const group = (...messages: unknown[]) => {
    // @ts-ignore
    if (import.meta.env.DEV) console.groupCollapsed("[DEV-ONLY]", ...messages);
  };

  const groupEnd = () => {
    // @ts-ignore
    if (import.meta.env.DEV) console.groupEnd();
  };

  return { log, warn, error, group, groupEnd };
};

export const debug = Object.assign(createDebug().log, {
  warn: createDebug().warn,
  error: createDebug().error,
  log: createDebug().log,
  group: createDebug().group,
  groupEnd: createDebug().groupEnd,
});
